import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet-async';
import { NEWS_DETAILS_GET, NEWS_DETAILS_RESET } from '../../redux/actions/news';
import { Container } from '../../../ui/gridSystem';
import { Badge, HtmlRaw, Text } from '../../../ui/atoms';
import { Cover, Categories, BadgeDateContainer } from './style';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import routes from '../../../routes';
import { getUrlWithToken, isPublicPath } from '../../../utils/common';
import { feBaseUrl } from '../../api/config';

const NewsDetails = ({ data, getNewsDetails, newsReset }) => {
  const { news_id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isPublic = () => isPublicPath(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!news_id) navigate(routes.home.path);
    getNewsDetails(news_id, isPublic());

    return () => newsReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [news_id]);

  const onClickCrumb = () => {
    if (isPublic()) navigate(routes.publicNews.path);
    else navigate(routes.news.path);
  };

  return (
    <>
      {isPublic() && (
        <Helmet>
          <title>SISFOR+ - Dettaglio news</title>
          <link rel="canonical" href={`${feBaseUrl}${pathname}`} />
          <meta name="description" content={data?.title || ''} />
        </Helmet>
      )}
      <Breadcrumb
        crumbs={[
          { label: 'Comunicazione', onClick: onClickCrumb },
          { label: data?.title },
        ]}
      />
      <Container className="pt-0">
        <Text type="h1" mb={16}>
          {data?.title}
        </Text>

        <Cover src={getUrlWithToken(data?.cover)} />

        <BadgeDateContainer>
          {data?.categories?.length > 0 && (
            <Categories>
              {data.categories.map((item, index) => (
                <Badge type="news" key={`item-${index}`}>
                  {item.name}
                </Badge>
              ))}
            </Categories>
          )}

          {data?.publication_from && (
            <Text type="b4" color="#515151">
              {dayjs(data.publication_from * 1000).format('DD/MM/YYYY')}
            </Text>
          )}
        </BadgeDateContainer>

        <Text type="b4" mb={64} className="news-body">
          <HtmlRaw html={data?.body} />
        </Text>
      </Container>
    </>
  );
};

NewsDetails.propTypes = {
  data: PropTypes.object,
  getNewsDetails: PropTypes.func,
  newsReset: PropTypes.func,
};

export default connect(
  (state) => {
    const { details: data } = state.news;
    return {
      data,
    };
  },
  (dispatch) => ({
    getNewsDetails: (id, isPublic) =>
      dispatch({ type: NEWS_DETAILS_GET._REQUEST, id, isPublic }),
    newsReset: () => dispatch({ type: NEWS_DETAILS_RESET }),
  })
)(NewsDetails);
